var urlParams = new URLSearchParams(window.location.search);
    
    if (urlParams.has('email')) {
        var email = urlParams.get('email');
      console.log('test');
        
        console.log('Email:', email);
        
        // You can use the email value as needed, for example:
        $("#email").val(email);
        // alert("Email: " + email); // Display an alert with the email value
    } else {
        console.log('Email parameter not found in the URL.');
    }
 
 var customPopupLoyalty = document.getElementById('custom-email-loyalty');
  customPopupLoyalty.addEventListener('click', function(e) {
    e.preventDefault();
    var emailPopValue = document.querySelector('input[name="contact[email]"]').value;
    window.location.href = "https://fifty.no/a/loyalty?email=" + encodeURIComponent(emailPopValue);
  });

  
